import { useEffect, useRef, useCallback } from "react";

export function useDebounce(callback, delay = 300) {
  const timeoutRef = useRef;
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const debouncedCallback = useCallback(
    (value) => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callbackRef.current(value); // Always use the latest callback
      }, delay);
    },
    [delay, timeoutRef]
  );

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [timeoutRef]);

  return debouncedCallback;
}
